const faviconDescriptors = [
  {
    href: '/favicon.ico',
    rel: 'shortcut icon',
  },
  {
    href: '/favicon.ico',
    rel: 'icon',
    sizes: 'any',
    type: 'image/x-icon',
  },
  {
    href: '/favicon-32x32.png',
    rel: 'icon',
    sizes: '32x32',
    type: 'image/png',
  },
  {
    href: '/favicon-16x16.png',
    rel: 'icon',
    sizes: '16x16',
    type: 'image/png',
  },
  {
    href: '/icon-192.png',
    rel: 'icon',
    sizes: '192x192',
    type: 'image/png',
  },
  {
    href: '/apple-touch-icon.png',
    rel: 'apple-touch-icon',
    sizes: '180x180',
    type: 'image/png',
  },
];

function buildAssetUrl(path) {
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${path}`;
}

export function refreshFavicons(doc = document) {
  if (!doc?.head) {
    return;
  }

  doc.head
    .querySelectorAll('link[rel="shortcut icon"], link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => link.remove());

  faviconDescriptors.forEach(({ href, rel, sizes, type }) => {
    const link = doc.createElement('link');
    link.setAttribute('rel', rel);
    link.setAttribute('href', buildAssetUrl(href));

    if (sizes) {
      link.setAttribute('sizes', sizes);
    }

    if (type) {
      link.setAttribute('type', type);
    }

    doc.head.appendChild(link);
  });
}
